import {
  type FC,
  type PropsWithChildren
} from 'react';
import {
  Stack
} from '@mui/joy';
import {
  PurchaseTwoPaneLayoutHeader,
  type PurchaseTwoPaneLayoutHeaderProps
} from './purchase-two-pane-layout-header.component';
import {
  PurchaseTwoPaneLayoutContent,
  type PurchaseTwoPaneLayoutContentProps
} from './purchase-two-pane-layout-content.component';

interface PurchaseTwoPaneLayoutType extends FC<PropsWithChildren<{ size?: 'sm' | 'md'; }>> {
  Header: FC<PurchaseTwoPaneLayoutHeaderProps>;
  Content: FC<PurchaseTwoPaneLayoutContentProps>;
};

export const PurchaseTwoPaneLayout: PurchaseTwoPaneLayoutType = ({ size = 'sm', children }) => (
  <Stack
    alignItems='center'
    justifyContent='center'
    sx={({ breakpoints }) => ({
      width: '100%',
      height: 'fit-content',
      [breakpoints.up(491)]: {
        paddingBlock: 5,
        paddingInline: 2,
      }
    })}>
    <Stack
      sx={({ breakpoints, palette }) => ({
        width: '100%',
        height: 'fit-content',
        [breakpoints.up(491)]: {
          maxWidth: 384,
          borderRadius: 8,
          backgroundColor: palette.common[475],
          ...((size === 'md' && ({ maxWidth: 750 }))),
        }
      })}>
      {children}
    </Stack>
  </Stack>
);

PurchaseTwoPaneLayout.Header = PurchaseTwoPaneLayoutHeader;
PurchaseTwoPaneLayout.Content = PurchaseTwoPaneLayoutContent;